import { render, staticRenderFns } from "./RefundMoney.vue?vue&type=template&id=1980a595&scoped=true"
import script from "./RefundMoney.vue?vue&type=script&lang=js"
export * from "./RefundMoney.vue?vue&type=script&lang=js"
import style0 from "./RefundMoney.vue?vue&type=style&index=0&id=1980a595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1980a595",
  null
  
)

export default component.exports